import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { sendAnalyticsEvents } from '../../analytics/common';
import { EVENTS } from '../../analytics/events';
import AppButton from '../../components/AppButton';
import AppSubtitle from '../../components/AppSubtitle';
import AppTitle from '../../components/AppTitle';
import { selectEventsData } from '../../store/events';
import { selectWebp } from '../../store/ui';
import useImagesSrc from '../../hooks/useImagesSrc';
import { selectLandingAnimation } from '../../store/plans';
import useWindowWidth from '../../hooks/useWindowWidth';
import { usePreloadImages } from '../../hooks/useImagePreloader';

const StyledImage = styled.div`
  background-image: ${({ imgSource }) => imgSource && `url('${imgSource}')`};
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  width: 100vw;
  max-height: 300px;
  height: 100%;
  @media screen and (min-width: 376px) {
    background-image: ${({ imgSource }) => imgSource && `url('${imgSource}')`};
    max-height: 512px;
    background-size: 110%;
    background-position: center;
  }
  @media screen and (min-width: 450px) {
    background-size: contain;
    min-height: 150px;
  }
`;

const StyledContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  // max-height: 80px;
  min-height: 150px;
  min-width: 330px;
  margin-bottom: 34px;
  @media screen and (min-width: 450px) {
    margin-bottom: 20px;
  }
`;

const CheckIns = () => {
  const navigate = useNavigate();
  const eventsData = useSelector(selectEventsData);
  const { t } = useTranslation();
  const isWebp = useSelector(selectWebp);
  const { imagesSources } = useImagesSrc();
  const isAnimationLanding = useSelector(selectLandingAnimation);
  const windowWidth = useWindowWidth();
  usePreloadImages(imagesSources.platformSupport);
  useEffect(
    () => sendAnalyticsEvents(EVENTS.onboardingCheckIn, eventsData),
    [eventsData]
  );

  const onContinueClick = () => {
    sendAnalyticsEvents(EVENTS.onboardingCheckInSubmitted, eventsData);
    navigate('/platform-support');
  };

  const imgSource = isAnimationLanding
    ? '../assets/desktop/anim/Check-ins.gif'
    : windowWidth >= 375 && isWebp
    ? '../assets/desktop/webp/Check-ins.webp'
    : windowWidth >= 375 && !isWebp
    ? '../assets/desktop/png/Check-ins.png'
    : windowWidth < 375 && isWebp
    ? '../assets/mobile/webp/Check-ins.webp'
    : '../assets/mobile/png/Check-ins.png';

  return (
    <>
      <StyledImage imgSource={imgSource} />
      <StyledContent>
        <AppTitle title={t('check_ins')} marginContainer={'0px 0px 12px 0px'} />
        <AppSubtitle
          containerWidth={'230px'}
          subtitle={t('check_ins_description')}
        />
      </StyledContent>
      <AppButton
        onClick={onContinueClick}
        bottomPosition={'24px'}
        customBeforeBg={'none'}
      >
        {t('continue')}
      </AppButton>
    </>
  );
};

export default CheckIns;
